var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors;
  return {
    colorGreen: colors.contrasts.green4570,
    colorBlue: colors.contrasts.blue4570,
    colorRed: colors.contrasts.red4570,
    colorGrey: colors.contrasts.grey4570,
    colorHeaderBottomBorder: colors.contrasts.grey1214,
    cellPadding: '13.5px 13.5px;'
  };
};
export default generateComponentTheme;